import { Col, Row, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Alerta } from '../../../../constants';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import TextAnexo from '../../../../components/text-anexo';
import TextItem from '../../../../components/text-item';
import { EmpresaBeneficiarioEmpresa, findByIdAndMap } from '../../../../constants';
import useFormatter from '../../../../hooks/useFormatter';
import useLoading from '../../../../hooks/useLoading';
import { beneficiariosEmpresaelector, fetchBeneficiarioEmpresa, isEditableSelector } from '../../../../store/empresa';
import { openPopup } from '../../../../util/window';
import useModulo from '../../../../hooks/useModulo';
import { useLocation } from "react-router";
import { useState } from "react";
import { beneficiariosEmpresaAlertaNivelSelector } from '../../../../store/empresa';
import TarefasDrawer from '../../licencas/_tarefasDrawer';

const { Apresentacao, Aceite } = EmpresaBeneficiarioEmpresa;

export default function EmpresaBeneficiarioEmpresaDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const beneficiarioEmpresa = useSelector(beneficiariosEmpresaelector);
  const { formatDateTime, formatDate, formatBoolean } = useFormatter();
  const loading = useLoading(fetchBeneficiarioEmpresa.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const nivel = useSelector(beneficiariosEmpresaAlertaNivelSelector);
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
    const location = useLocation();
    const pathname = location.pathname;
    const origem = pathname.substring(pathname.indexOf("/empresas"));
    const modulo = pathname.split("/")[1];
    const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/beneficiarios-empresa/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/beneficiarios-empresa`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/beneficiarios-empresa/${id}/`, `logs_/empresas/${empresaId}/beneficiarios-empresa/${id}/`);
  };

  return (
    <Spin spinning={loading}>
        <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId}  onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t('Aplicável')}>{formatBoolean(beneficiarioEmpresa?.aplicavel)}</TextItem>
        </Col>
        <Col flex="200px">
          {beneficiarioEmpresa?.aplicavel === true && <TextItem label={t('Informado em')}>{formatDate(beneficiarioEmpresa?.dataAplicavel)}</TextItem>}
        </Col>
        <Col flex="200px">
          {beneficiarioEmpresa?.aplicavel === true && (
            <TextItem label={t('Data Limite da Apresentação')}>{formatDate(beneficiarioEmpresa?.dataLimiteApresentacao)}</TextItem>
          )}
        </Col>
      </Row>
      {beneficiarioEmpresa?.aplicavel === true && (
        <>
          <Row gutter={[16, 8]}>
            <Col flex="200px">
              <TextItem label={t('Apresentação')}>
                {findByIdAndMap(Apresentacao, beneficiarioEmpresa?.apresentacao, (apresentacao) => t(apresentacao.label))}
              </TextItem>
            </Col>
            <Col flex="200px">
              {beneficiarioEmpresa?.apresentacao === Apresentacao.Sim.id && (
                <TextItem label={t('Data de Apresentação')}>{formatDate(beneficiarioEmpresa?.dataApresentacao)}</TextItem>
              )}
            </Col>
            <Col flex="200px">
              {beneficiarioEmpresa?.apresentacao === Apresentacao.Sim.id && (
                <TextItem label={t('Aceite')}>{findByIdAndMap(Aceite, beneficiarioEmpresa?.aceite, (aceite) => t(aceite.label))}</TextItem>
              )}
            </Col>
            <Col flex="200px">
              {beneficiarioEmpresa?.aceite === Aceite.Sim.id && <TextItem label={t('Data de Aceite')}>{formatDate(beneficiarioEmpresa?.dataAceite)}</TextItem>}
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col flex="800px">
              <TextAnexo label={t('Anexo')} value={beneficiarioEmpresa?.anexo} />
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col flex="800px">
              <TextItem label={t('Observação')}>{beneficiarioEmpresa?.obs}</TextItem>
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col flex="200px">
              <TextItem label="Criado em">{formatDateTime(beneficiarioEmpresa?.createdAt)}</TextItem>
            </Col>
            <Col flex="200px">
              <TextItem label="Alterado em">{formatDateTime(beneficiarioEmpresa?.updatedAt)}</TextItem>
            </Col>
            <Col flex="200px">
              <TextItem label="Id">{beneficiarioEmpresa?.id}</TextItem>
            </Col>
          </Row>
        </>
      )}
    </Spin>
  );
}
